<script>
import _ from "lodash";

export default {
    name: "VDialogConfirm",
    props: {
        caption: {
            type: String,
            default: 'Подтверждение',
        },
        type: {
            type: String,
            default: 'confirm',
        },
        maxWidth: {
            default: '750px',
        },
    },
    inheritAttrs: false,
    data() {
        return {
            isShow: false,
            isResolved: true,
            isSubmit: false,
            isValid: false,
            data: null,
            result: false,
        };
    },
    computed: {
        isDisabled() {
            return !this.isResolved || this.isSubmit;
        },
        handlers() {
            const defaultHandlers = {
                close: {fns: () => false},
            };
            return _(defaultHandlers)
                .assign(this.$listeners)
                .mapValues((handler) => {
                    const self = this;
                    return function () {
                        self.isSubmit = true;
                        return Promise.resolve(handler.fns.apply(null, arguments))
                            .then(response => {
                                self.result = response;
                                return response;
                            })
                            .catch(self.reject)
                            .finally(() => {
                                self.isSubmit = false;
                                self.close();
                            });
                    }
                })
                .value();
        },
    },
    watch: {
        isShow(v) {
            if (!v) {
                this.resolve(this.result);
                this.result = false;
            }
        },
    },
    methods: {
        show(data = {}) {
            this.data = data;
            this.isShow = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        close() {
            this.isShow = false;
        },
    },
}
</script>

<template>
    <v-dialog
        v-if="isShow"
        v-model="isShow"
        :max-width="maxWidth"
        :persistent="isSubmit"
        scrollable
    >
        <v-card :loading="isDisabled">
            <v-card-title>{{ caption }}</v-card-title>

            <v-card-text>
                <v-form v-model="isValid">
                    <slot v-bind="{data, isResolved, isDisabled}">
                        <template v-if="type === 'delete'">
                            Удалить запись?
                        </template>
                    </slot>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <slot name="actions" v-bind="{handlers, isDisabled}">
                    <v-spacer></v-spacer>
                    <template v-if="type === 'delete'">
                        <v-btn v-if="handlers.confirm" @click="handlers.confirm(data)" :disabled="isDisabled || !isValid">
                            Да, удалить
                        </v-btn>
                        <v-btn v-if="handlers.close" @click="handlers.close(data)" :disabled="isDisabled">
                            Нет, не удалять
                        </v-btn>
                    </template>
                    <template v-else-if="type === 'confirm'">
                        <v-btn v-if="handlers.confirm" @click="handlers.confirm(data)" :disabled="isDisabled || !isValid">
                            Да, подтверждаю
                        </v-btn>
                        <v-btn v-if="handlers.close" @click="handlers.close(data)" :disabled="isDisabled">
                            Нет, не подтверждаю
                        </v-btn>
                    </template>
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped lang="scss">

</style>
